const initialState = {
  vrItems: [],
  vrItem: null,
  threeSixtyProjects: [],
  total: 0,
  loading: false,
  error: null,
};

export const vrHomeVrReducer = (state = initialState, action) => {
  switch (action.type) {

    case "VR_LIST_REQUEST":
      return { ...state, loading: true, error: null };
    case "VR_LIST_SUCCESS":
      // API response shape: { statusCode, status, message, total, data: [...] }
      return {
        ...state,
        loading: false,
        vrItems: action.payload.data || [],
        total: action.payload.total || 0,
        error: null,
      };
    case "VR_LIST_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "VR_ADD_REQUEST":
      return { ...state, loading: true, error: null };
    case "VR_ADD_SUCCESS":
      return { ...state, loading: false, error: null };
    case "VR_ADD_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "VR_UPDATE_REQUEST":
      return { ...state, loading: true, error: null };
    case "VR_UPDATE_SUCCESS":
      return { ...state, loading: false, vrItem: action.payload.data || null, error: null };
    case "VR_UPDATE_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "VR_VIEW_REQUEST":
      return { ...state, loading: true, error: null };
    case "VR_VIEW_SUCCESS":
      return { ...state, loading: false, vrItem: action.payload.data || null, error: null };
    case "VR_VIEW_FAIL":
      return { ...state, loading: false, error: action.payload, vrItem: null };

    case "VR_THREE_SIXTY_PROJECTS_REQUEST":
      return { ...state, loading: true, error: null };
    case "VR_THREE_SIXTY_PROJECTS_SUCCESS":
      return { ...state, loading: false, threeSixtyProjects: action.payload.data || [], error: null };
    case "VR_THREE_SIXTY_PROJECTS_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "CLEAR_ERRORS":
      return { ...state, error: null };

    default:
      return state;
  }
};